var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransferCart = function SvgTransferCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 16 16.13"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#transfer-cart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.567 3.429H7.424c-.631 0-1.143.511-1.143 1.143v5.142c0 .632.512 1.143 1.143 1.143h5.143c.631 0 1.143-.511 1.143-1.143V4.572c0-.632-.512-1.143-1.143-1.143ZM4.57 13.714h8.697c.3.002.588.12.8.332l1.36 1.383M.57.572h1.143a1.143 1.143 0 0 1 1.143 1.142v9.715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.574 13.429a1.989 1.989 0 1 1-3.968.286 1.989 1.989 0 0 1 3.968-.286ZM9.71 8h1.144"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-cart_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgTransferCart;